var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-sign-call-back-view',{attrs:{"message-key":"TaskList.identification.verifying"}})}
var staticRenderFns = []

export { render, staticRenderFns }